export { default as skywallethdk1 } from './skywallet_hdk_1.png';
export { default as skywallethdk2 } from './skywallet_hdk_2.png';
export { default as skywallethdk3 } from './skywallet_hdk_3.png';
export { default as skywallethdk4 } from './skywallet_hdk_4.png';
export { default as skywallethdk5 } from './skywallet_hdk_5.png';
export { default as skywallethdk6 } from './skywallet_hdk_6.png';
export { default as skywallethdk7 } from './skywallet_hdk_7.png';
export { default as skywallethdk8 } from './skywallet_hdk_8.png';
export { default as skywallethdk9 } from './skywallet_hdk_9.png';
export { default as skywallethdk10 } from './skywallet_hdk_10.png';
export { default as skywallethdk11 } from './skywallet_hdk_11.png';
export { default as skywallethdk12 } from './skywallet_hdk_12.png';



// WEBPACK FOOTER //
// ./src/components/SkywalletHDK/components/GalleryHDK/images/index.js